import { useSend } from './SendContext';

/**
 * Yes / No buttons rendered under an assistant turn that asked
 * "want me to answer from general knowledge?" (server-side
 * `awaiting_fallback_decision: true`).
 *
 * Click → SendContext.decide('accept'|'decline'). The server
 * reads the original query from session and short-circuits to
 * either an LLM-from-general-knowledge answer or a polite
 * refusal. SendContext optimistically clears the awaiting flag
 * so the buttons disappear instantly; the refetched conversation
 * then carries the follow-up message.
 *
 * History-restore turns NEVER carry awaiting_fallback_decision
 * (chat_service strips it), so this component only ever appears
 * on a fresh prompt - same posture as the legacy renderer.
 */
export function FallbackDecisionButtons() {
  const { decide, isPending } = useSend();

  return (
    <div className="fallback-decision">
      <button
        type="button"
        className="fallback-decision-btn fallback-decision-btn-yes"
        onClick={() => decide('accept')}
        disabled={isPending}
      >
        Yes
      </button>
      <button
        type="button"
        className="fallback-decision-btn fallback-decision-btn-no"
        onClick={() => decide('decline')}
        disabled={isPending}
      >
        No
      </button>
    </div>
  );
}
